import { render, staticRenderFns } from "./CustomerBottomNav.vue?vue&type=template&id=8acf389c&scoped=true&"
import script from "./CustomerBottomNav.vue?vue&type=script&lang=ts&"
export * from "./CustomerBottomNav.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerBottomNav.vue?vue&type=style&index=0&id=8acf389c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acf389c",
  null
  
)

export default component.exports